import type { VideoCall } from '@/types'

type RTCJoinPhase = 'join_attempt' | 'join_failed'

const sensitiveKeyPattern = /authorization|access_token|refresh_token|rtc_token|token|secret|password|credential|cookie|api_key|apikey/i

export function rtcJoinMetadata(
  call: VideoCall | null | undefined,
  phase: RTCJoinPhase,
  error?: unknown
): Record<string, unknown> {
  const metadata: Record<string, unknown> = {
    phase,
    app_id: call?.app_id || call?.provider_app_id,
    rtc_channel: call?.channel_name || call?.rtc_channel,
    rtc_uid: call?.uid,
    expire_at: call?.expire_at,
    now: Math.floor(Date.now() / 1000),
    has_rtc_auth: Boolean(call?.rtc_token),
  }
  const rtcError = rtcErrorMetadata(error)
  if (rtcError) {
    metadata.error = rtcError
  }
  return metadata
}

function rtcErrorMetadata(error: unknown): Record<string, unknown> | undefined {
  if (!error || typeof error !== 'object') {
    return error ? { message: String(error) } : undefined
  }
  const record = error as Record<string, unknown>
  const metadata: Record<string, unknown> = {
    name: typeof record.name === 'string' ? record.name : error instanceof Error ? error.name : undefined,
    message: typeof record.message === 'string' ? record.message : error instanceof Error ? error.message : undefined,
    code: typeof record.code === 'string' || typeof record.code === 'number' ? record.code : undefined,
  }
  Object.entries(record).forEach(([key, value]) => {
    if (sensitiveKeyPattern.test(key) || key in metadata) {
      return
    }
    if (['string', 'number', 'boolean'].includes(typeof value) || value == null) {
      metadata[key] = value
    }
  })
  return metadata
}
